import React from 'react';

import Section, { InfoCard, SectionHeader } from 'views/site/Section.js';
import Theme from 'styles/Theme.js';
import Utils from 'files/Utils.js';

/*
 * Guarantee
 *
 * Risk reversal, quoted from the warranty pages of the owner's manuals rather
 * than written as marketing. The three commitments are distinct and are often
 * conflated, so they are stated separately:
 *
 *   Lifetime Fire Replacement Guarantee   a sensor damaged or destroyed by an
 *                                         accidental fire is replaced at no
 *                                         cost, with a fire department report,
 *                                         within 90 days of the fire.
 *   Limited Warranty                      24 months from purchase against
 *                                         defects in workmanship and materials.
 *   Lifetime Product Replacement          from the 25th month onward, discounted
 *                                         replacement for the life of the
 *                                         original owner.
 *
 * The conditions are summarised honestly — a guarantee page that hides the
 * conditions is worse than no guarantee page.
 */

const Guarantee = () => {

    const mobile = Utils.isMobile();

    const items = [{
        copy: 'A sensor damaged or destroyed by an accidental fire is replaced at no cost to the original owner. Return it within 90 days with the fire department’s report.',
        icon: 'thermometer-snow',
        title: 'Lifetime fire replacement'
    },{
        copy: 'Twenty-four months from purchase against defects in workmanship, materials and construction under normal use — repaired or replaced free of charge.',
        icon: 'shield-check',
        title: '2 year limited warranty'
    },{
        copy: 'From the 25th month onward, the manufacturer will replace a sensor at a preferred discounted price for as long as you own it. Annual cleaning per the manual applies.',
        icon: 'infinity',
        title: 'Lifetime product replacement'
    },{
        copy: 'There is no subscription and no monitoring contract, so nothing has to be paid each month to keep the alerts working. Pay for the network up front or over time; either way it is yours once it is paid for.',
        icon: 'slash-circle',
        title: 'No monitoring fees'
    }];

    return (
        <Section id={'guarantee'} tinted>
            <SectionHeader
            eyebrow={'Buy with confidence'}
            subtitle={'The equipment is built to last a decade on a sealed battery, with no annual battery change and nothing to remember. These are the promises that sit behind it, written in plain terms rather than buried in a warranty booklet. If something fails inside them, it is ours to put right rather than yours to prove.'}
            title={'What happens if something goes wrong'} />

            <div style={{
                display: 'grid',
                gap: mobile ? 16 : 20,
                gridTemplateColumns: mobile ? '1fr' : 'repeat(2, 1fr)'
            }}>
                {items.map((item, index) => (
                    <InfoCard key={index} {...item} />
                ))}
            </div>

            <span style={{
                ...Theme.textStyles.caption({ color: Theme.colors.lightGrey, textAlign: 'center' }),
                display: 'block',
                marginTop: 24
            }}>{'Full terms, conditions and exclusions are in the owner’s manual supplied with every device.'}</span>
        </Section>
    )
}

export default Guarantee;
